module.exports = __webpack_public_path__ + "img/图1-37椭圆的徒手画法.736eba58.jpg";